export default "__VITE_ASSET__DSlkiMVR__"